export const NAVIGATION_MODES = {
  ASSISTANT: "assistant",
  ACCOUNT: "account",
  ADMIN: "admin"
};

export const DRAWER_WIDTH = 240;
export const COLLAPSED_DRAWER_WIDTH = 64;
export const NAV_ITEM_HEIGHT = 38;
export const COLLAPSED_NAV_ITEM_SIZE = 48;
export const COLLAPSED_NAV_ITEM_BORDER_RADIUS = "2px";
export const NAV_ICON_BOX_SIZE = 24;
export const NAV_ICON_GLYPH_SIZE = 18;
export const COLLAPSED_DIVIDER_WIDTH = 32;
export const NAV_LABEL_MAX_WIDTH = "150px";
export const TOOLTIP_BORDER_RADIUS = "4px";

export const NAVIGATION_LABELS = {
  collapseNavigation: "Collapse navigation",
  expandNavigation: "Expand navigation"
};

export const NAVIGATION_DOM_IDS = {
  sectionRegion: sectionKey => `navigation-section-${sectionKey}`,
  itemChildrenRegion: itemKey => `navigation-item-children-${itemKey}`
};

export const NAVIGATION_TEST_IDS = {
  collapseToggle: "navigation-collapse-toggle",
  sectionToggle: sectionKey => `navigation-section-toggle-${sectionKey}`,
  item: text => `navigation-item-${text}`
};
